import { MobileVariant } from "../../types";
import styled from "styled-components";
export const MainStepContainer = styled.div `
  display: grid;
  grid-template-columns: 34px auto;
  font-size: 18px;
  margin: ${(props) => props.isMobileLayout &&
    props.mobileVariant === MobileVariant.HORIZONTAL_LINE
    ? "10px 0"
    : "0"};
`;
//# sourceMappingURL=styled.js.map